export const safeGtag = (command, action, params) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(command, action, params);
  } else {
    // Fallback for environments without GA4 loaded or for debugging
    console.debug(`[GA4 Tracking Fallback] ${command} | ${action}`, params);
  }
};

const getPageData = () => ({
  page_path: typeof window !== 'undefined' ? window.location.pathname : '',
  page_title: typeof document !== 'undefined' ? document.title : 'Hiperpan'
});

export const trackScrollDepth = (percentage) => {
  safeGtag('event', 'scroll_depth', {
    ...getPageData(),
    scroll_percentage: percentage
  });
};

export const trackCtaClick = (ctaText, ctaLocation, ctaType = 'button') => {
  safeGtag('event', 'cta_click', {
    ...getPageData(),
    cta_text: ctaText,
    cta_location: ctaLocation,
    cta_type: ctaType
  });
};

export const trackFormFieldBlur = (fieldName, fieldValueLength) => {
  safeGtag('event', 'form_field_blur', {
    ...getPageData(),
    field_name: fieldName,
    field_length: fieldValueLength
  });
};

export const trackFormSubmit = (formName, fieldsFilledCount) => {
  safeGtag('event', 'form_submit', {
    ...getPageData(),
    form_name: formName,
    fields_filled: fieldsFilledCount
  });
};

export const trackWhatsAppClick = (location) => {
  safeGtag('event', 'whatsapp_click', {
    ...getPageData(),
    click_location: location
  });
};

export const trackSocialClick = (network, location) => {
  safeGtag('event', 'social_click', {
    ...getPageData(),
    social_network: network,
    click_location: location
  });
};